export const RECENT_AUTOCOMPLETE = "autocomplete.websitesMain.seperator.text.recents";
export const SUGGESTED_AUTOCOMPLETE = "common.suggested.websites";
